import { Button, Dialog } from '@givmo/design-system';

/**
 * The module's confirm dialog: the SaaS dialog treatment the org console and this package's campaign
 * dialogs use (e.g. `org-deactivation.tsx`), a titled card with the body subordinate beneath it.
 * Every confirm in the package renders through it (the editor's publish, close, reopen and upgrade;
 * the campaign's invite revoke, FCM-WEB22), so a confirm can never fall back to Base UI's unstyled,
 * body-weight title.
 */
export function ConfirmDialog({
  open,
  onOpenChange,
  title,
  body,
  confirmLabel,
  cancelLabel = 'Cancel',
  testId,
  confirmTestId,
  cancelTestId,
  onConfirm,
  busy = false,
  disabled = false,
  tone = 'primary',
  informational = false,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  body: string;
  confirmLabel: string;
  /** The way out's label; "Cancel" unless the act itself is a cancel ("Keep it"). */
  cancelLabel?: string;
  testId: string;
  confirmTestId: string;
  cancelTestId?: string;
  onConfirm: () => void;
  busy?: boolean;
  disabled?: boolean;
  tone?: 'primary' | 'danger';
  informational?: boolean;
}) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Content className="fundraisers-dialog flex flex-col gap-16" testId={testId}>
        <Dialog.Title className="font-sans text-s18 font-w700 tracking-givmo text-text-strong">
          {title}
        </Dialog.Title>
        <Dialog.Description className="font-sans text-s14 font-w400 leading-h15 tracking-givmo text-text-secondary">
          {body}
        </Dialog.Description>
        <div className="mt-8 flex justify-end gap-8">
          {!informational && (
            <Button
              appearance="saas"
              tone="secondary"
              disabled={busy}
              testId={cancelTestId ?? `${testId}-cancel`}
              onClick={() => onOpenChange(false)}
            >
              {cancelLabel}
            </Button>
          )}
          <Button
            appearance="saas"
            tone={tone}
            loading={busy}
            disabled={disabled || busy}
            testId={confirmTestId}
            onClick={onConfirm}
          >
            {confirmLabel}
          </Button>
        </div>
      </Dialog.Content>
    </Dialog.Root>
  );
}
